// Actions only describe what happened,
// but don't describe how the application's state changes.

/*  name each action (constant) as <NOUN>_<VERB> with the present tense: TODO_ADD
action creator name: <verb><Noun>: addTodo
selector name: get<Noun> */

export const setImportStatus = status => ( {
	type: 'IMPORT_PROGRESS_STATUS_SET',
	status,
} );

export const setImportProgress = imported => ( {
	type: 'IMPORT_PROGRESS_SET',
	imported,
} );

export const setImportTotal = total => ( {
	type: 'IMPORT_PROGRESS_TOTAL_SET',
	total,
} );

export const setCurrentPanel = newId => ( {
	type: 'CURRENT_PANEL_SET',
	newId,
} );




// WEBPACK FOOTER //
// ./src/actions/ui-actions.js